import React, { useState, useEffect } from 'react'
import { Table, Panel, Row, Col, Icon, Checkbox, Modal, Message } from 'rsuite'
import { getUserProfile } from '../../redux/actions/dashboard'
import './styles.less'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import { budgetFormat } from '../../utils/formatterUtil'
import { cloneDeep } from 'lodash-es'
import LoaderProcessing from '../../components/loader/LoaderProcessing'
import { getRegisterMailBox, saveRegisterMailBox } from '../../redux/actions/registerMailbox'
import { DEFAULT_ERR_MSG, SAVE_SUCCESS_MSG } from '../../constants/msgText'
import { Controller, useForm } from 'react-hook-form'
import InputForm from '../../components/forms/input/InputForm'
import notification from '../../utils/notification'
import ConfirmWidget from '../confirm/ConfirmWidget'

export default function Profile({ userType }) {
  const { Column, HeaderCell, Cell } = Table

  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const [schema, setSchema] = useState()
  const [isRegisterMailBox, setIsRegisterMailBox] = useState()
  const [registerSchema, setRegisterSchema] = useState()
  const [registerData, setRegisterData] = useState()
  const [registerSelectAll, setRegisterSelectAll] = useState()
  const [isRegisterMailBoxLoading, setIsRegisterMailBoxLoading] = useState(false)
  const [saveRegisterError, setSaveRegisterError] = useState()
  const [registerMailBoxReq, setRegisterMailBoxReq] = useState()
  const [isShowConfirm, setIsShowConfirm] = useState()
  const [isSaveRegisterErrorLoading, setIsSaveRegisterErrorLoading] = useState(false)

  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()

  const styleText = { marginBottom: 10 }

  useEffect(() => {
    handelGetSchemaDashboard()
  }, [])

  const handelGetSchemaDashboard = async () => {
    setIsLoading(true)
    try {
      const response = await getUserProfile()
      setSchema(response)
    } catch (e) {
      setError({})
    }
    setIsLoading(false)
  }

  const doGetRegisterMailBox = async () => {
    setIsRegisterMailBoxLoading(true)
    try {
      let response = await getRegisterMailBox()
      let map = new Map()
      let isOneUnSelected = false
      response?.values?.forEach((e) => {
        if (!e.registered) {
          isOneUnSelected = true
        }
        map.set(e.projectCode, e.registered)
      })

      setRegisterSelectAll(!isOneUnSelected)
      setRegisterData(map)
      setRegisterSchema(response)
      setIsRegisterMailBox(true)
    } catch (e) {
      setError({})
    }
    setIsRegisterMailBoxLoading(false)
  }

  const handelSaveRegisterMailBox = async () => {
    setIsSaveRegisterErrorLoading(true)
    setIsShowConfirm(false)
    try {
      let response = await saveRegisterMailBox(registerMailBoxReq)

      if (response?.isSuccess) {
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
          duration: 5000,
        })
        setIsRegisterMailBox(false)
        setSaveRegisterError('')
      } else {
        setSaveRegisterError(response.message || DEFAULT_ERR_MSG)
      }
    } catch (e) {
      setSaveRegisterError(DEFAULT_ERR_MSG)
    }

    setIsSaveRegisterErrorLoading(false)
  }

  const onSubmitRegisterMailBox = (data) => {
    let details = []
    registerData?.forEach((values, keys) => {
      details.push({ projectCode: keys, registered: values })
    })

    let request = {
      email: data.email,
      detail: details,
    }
    // console.log('request : ', request)
    setIsShowConfirm(true)
    setRegisterMailBoxReq(request)
  }

  return (
    <>
      {schema && (
        <Panel bordered shaded style={{ marginTop: 15 }}>
          <Row>
            <Col
              xs={24}
              sm={5}
              md={3}
              lg={3}
              style={{
                textAlign: 'center',
                marginTop: 10,
              }}
            >
              <Panel>
                <Icon icon="user-circle" size="5x"></Icon>
              </Panel>
            </Col>
            <Col
              xs={24}
              sm={schema.projectCounter ? 12 : 19}
              md={schema.projectCounter ? 16 : 21}
              lg={schema.projectCounter ? 16 : 21}
            >
              <Panel>
                <Row>
                  <Col xs={24} sm={24} md={14} lg={14} style={styleText}>
                    <strong>ชื่อ : </strong> {schema.name}
                  </Col>
                  <Col xs={24} sm={24} md={10} lg={10} style={styleText}>
                    <strong>บทบาทหน้าที่ : </strong> {schema.role}
                  </Col>
                  {schema.role !== 'coworker' && schema.role !== 'reviewer' && (
                    <>
                      <Col xs={24} sm={24} md={14} lg={14} style={styleText}>
                        <strong>ตำแหน่ง : </strong> {schema.position}
                      </Col>
                      <Col xs={24} sm={24} md={10} lg={10} style={styleText}>
                        <strong>สำนัก : </strong> {schema.departmentName}
                      </Col>
                    </>
                  )}
                  <Col xs={24} sm={14} md={14} style={styleText}>
                    <strong>วันที่เข้าใช้ล่าสุด : </strong> {new Date().toLocaleString()}
                  </Col>
                  {schema.verifyKyc && (
                    <Col xs={24} sm={10} md={10} style={styleText}>
                      {schema.verifyKyc.value ? (
                        <>
                          <div style={{ color: '#2da888' }}>
                            <Icon icon="check-circle" size="lg" />
                            {`  ${schema.verifyKyc.label}`}
                          </div>
                        </>
                      ) : (
                        <>
                          <div style={{ color: '#fb8a81' }}>
                            <Icon icon="close-circle" size="lg" />
                            {`  ${schema.verifyKyc.label}`}
                          </div>
                        </>
                      )}
                    </Col>
                  )}
                </Row>
              </Panel>
            </Col>

            {schema.projectCounter && (
              <Col xs={24} sm={7} md={5} lg={5}>
                <Panel
                  bordered
                  //style={{ borderRadius: 15, borderStyle: 'solid', borderWidth: 3 }}
                >
                  <Row>
                    <Col
                      xs={24}
                      sm={24}
                      md={24}
                      lg={24}
                      style={{ textAlign: 'center', marginBottom: 10, fontSize: '1.1rem' }}
                    >
                      <strong>{schema.projectCounter.header || 'โครงการทั้งหมด'}</strong>
                    </Col>
                    <Col xs={24} sm={12} md={12} lg={12} style={{ textAlign: 'center' }}>
                      <p style={{ color: '#2DA888', fontSize: '1.4rem' }}>
                        <strong>{schema.projectCounter.myProjectCount}</strong>
                      </p>
                      <p style={{ fontSize: '1.1rem' }}>
                        <strong>{schema.projectCounter.myProjectLabel || 'ของฉัน'}</strong>
                      </p>
                    </Col>
                    <Col xs={24} sm={12} md={12} lg={12} style={{ textAlign: 'center' }}>
                      <p style={{ color: '#2DA888', fontSize: '1.4rem' }}>
                        <strong>{schema.projectCounter.deparmentCount}</strong>
                      </p>
                      <p style={{ fontSize: '1.1rem' }}>
                        <strong>{schema.projectCounter.deparmentProjectLabel || 'ของสำนัก'}</strong>
                      </p>
                    </Col>
                  </Row>
                </Panel>
              </Col>
            )}
          </Row>
          {schema.registerMailBox && (
            <div style={{ textAlign: 'right', marginBottom: -20 }}>
              <div
                style={{
                  display: 'inline-block',
                  marginRight: 15,
                }}
              >
                <div>
                  <a href="https://digitalpostbox.promptpost.com/" target="_blank">
                    <div style={{ textAlign: 'right' }}>
                      <strong>
                        <span>
                          คลิก ตู้ไปรษณีย์ดิจิทัลภาครัฐ <br />(
                          <span style={{ color: '#1c2b89' }}> Digital</span>
                          <span style={{ color: '#fc391d' }}> Postbox</span> )
                        </span>
                      </strong>
                    </div>
                  </a>
                </div>
              </div>
              <div
                style={{
                  display: 'inline-block',
                }}
              >
                <div>
                  <SaveButton
                    icon="order-form"
                    children="ลงทะเบียน Digital Postbox"
                    onClick={doGetRegisterMailBox}
                    style={{ marginBottom: 30 }}
                  />
                </div>
              </div>
            </div>
          )}
        </Panel>
      )}

      <Modal
        full
        // size="lg"
        placement="top"
        backdrop="static"
        show={isRegisterMailBox}
        onHide={() => {
          setIsRegisterMailBox(false)
        }}
      >
        <Modal.Header>
          <Modal.Title>{registerSchema?.header}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ marginLeft: 20, marginRight: 20 }}>
            {isRegisterMailBoxLoading ? (
              <LoaderProcessing />
            ) : (
              <>
                {registerSchema?.inputForm && (
                  <div style={{ marginBottom: 20 }}>
                    <InputForm
                      schema={registerSchema?.inputForm?.email}
                      register={register}
                      Controller={Controller}
                      control={control}
                      errors={errors}
                      setValue={setValue}
                      clearErrors={clearErrors}
                      inputMdlg={10}
                    />
                  </div>
                )}

                <Checkbox
                  name="selectAll"
                  checked={registerSelectAll}
                  onChange={(_, check) => {
                    let map = new Map()

                    registerSchema?.values?.forEach((e) => {
                      map.set(e.projectCode, check)
                    })
                    console.log('map : ', map)

                    setRegisterSelectAll(check)
                    setRegisterData(map)
                  }}
                >
                  เลือกทั้งหมด
                </Checkbox>
                <Table
                  rowKey="projectId"
                  // height={mock.values}
                  autoHeight
                  wordWrap={true}
                  data={registerSchema?.values}
                >
                  <Column width={80} align="center">
                    <HeaderCell>เลือก</HeaderCell>
                    <Cell>
                      {(rowData) => {
                        let check = registerData.get(rowData.projectCode)
                        return (
                          <>
                            <Checkbox
                              name={rowData.projectCode}
                              // disabled={rowData.registered}
                              checked={check}
                              onChange={(_, check) => {
                                let data = cloneDeep(registerData)
                                data.set(rowData.projectCode, check)

                                var isUnSelected = [...data].find(([key, value]) => value == false) //[0]
                                isUnSelected
                                  ? setRegisterSelectAll(false)
                                  : setRegisterSelectAll(true)

                                setRegisterData(data)
                              }}
                            />
                          </>
                        )
                      }}
                    </Cell>
                  </Column>
                  <Column width={150}>
                    <HeaderCell>รหัสโครงการ</HeaderCell>
                    <Cell dataKey={'projectCode'} />
                  </Column>
                  <Column width={250} minWidth={250} flexGrow={1}>
                    <HeaderCell>ชื่อโครงการ</HeaderCell>
                    <Cell dataKey={'projectName'} />
                  </Column>
                  <Column width={160} align="center">
                    <HeaderCell>สถานะโครงการ</HeaderCell>
                    <Cell dataKey={'statusName'} />
                  </Column>
                  <Column width={200} align="right">
                    <HeaderCell>งบประมาณโครงการ</HeaderCell>
                    <Cell>
                      {(rowData) => {
                        return budgetFormat(rowData.budget)
                      }}
                    </Cell>
                  </Column>
                  <Column width={200}>
                    <HeaderCell>Digital Postbox</HeaderCell>
                    <Cell dataKey={'email'} />
                  </Column>
                </Table>
              </>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          {saveRegisterError && (
            <Message
              style={{ textAlign: 'left', marginBottom: 10 }}
              showIcon
              type="error"
              description={saveRegisterError}
            />
          )}

          <SaveButton
            disabled={isRegisterMailBoxLoading || isSaveRegisterErrorLoading}
            children="บันทึก"
            onClick={handleSubmit(onSubmitRegisterMailBox)}
          />
          <CancelButton
            children="ยกเลิก"
            onClick={() => {
              setIsRegisterMailBox(false)
              setSaveRegisterError('')
            }}
          />
        </Modal.Footer>
      </Modal>

      <ConfirmWidget
        title={`ยืนยันการ`}
        show={isShowConfirm}
        detail={`ยืนยันการบันทึก`}
        onCancle={() => {
          setIsShowConfirm(false)
          setRegisterMailBoxReq({})
        }}
        onConfirm={handelSaveRegisterMailBox}
      />
    </>
  )
}
